import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'

export const PlaylistChart: React.FunctionComponent = ({ }) => {
    const [groupBy, setGroupBy] = React.useState<string | undefined>('downloads')
    const toolbarItems = GroupByType([{ val: 'downloads', display: 'Downloads' }, { val: 'streams', display: 'Streams' }], groupBy, (selected) => {
        setGroupBy(selected)
    }, false)
    return (
        <BPMChart title='Top Playlists' subTitle={'By ' + (groupBy == 'downloads' ? 'Downloads' : 'Streams')} type='bar'
            key={groupBy}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>(`playlist/${groupBy}/byGroup`, options, signal)
            }} additionalParams={{ groupBy: 'name' }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: groupBy == 'downloads' ? 'Downloads' : 'Streams', valueField: 'count', argumentField: 'name',
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Playlist/charts/PlaylistChart.tsx